import { useState } from "react";
import SchoolHeader from "@/components/SchoolHeader";
import NavBar from "@/components/NavBar";
import AppSidebar from "@/components/AppSidebar";
import AppFooter from "@/components/AppFooter";

export default function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <SchoolHeader />
      <NavBar onOpenSidebar={() => setSidebarOpen(true)} />
      <AppSidebar open={sidebarOpen} onOpenChange={setSidebarOpen} />
      <main className="flex-1 max-w-7xl w-full mx-auto px-3 md:px-6 py-6">
        {children}
      </main>
      <AppFooter />
    </div>
  );
}
